// $(document).ready(function() {
//   $(document).on('click','.collection-top-bar__filters .collection__button',function(){
//     var click_filter = $(this).data('filter-open');
//     $('.collection-flyout__wash').addClass('active');
//     // $(".collection-flyout.drawer").each(function() {
//     //   var filter_value = $(this).data('filter-flyout');
//     //   if(filter_value == click_filter){
//     //     $(this).addClass('active');
//     //   }
//     // });
//     $('.collection-flyout.drawer[data-filter-flyout='+click_filter+']').addClass('active');
//     //console.log(click_filter);
//   });
// });

$('.banner_slider .banner_list').slick({
  dots: true,
  infinite: true,
  arrows: false,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true
});

$('.featured_collection_slider .product_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1401,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 371,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.reviews_inner .customer_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
});


$('.product-thumbnails .product-thumbnails__list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 371,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

document.addEventListener( 'DOMContentLoaded', function () {
  $('.description_main ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
}, false );


if ($(window).width() < 551) {
$('.announcement_inner ul.info_list').slick({
  dots: false,
  infinite: true,
  arrows: true,
  autoplay:true,
  autoplaySpeed:1500,
  speed: 300,
  slidesToShow: 1
});
}


setTimeout(function () {
$('.recommendations_slider .product_list').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1401,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
         {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 371,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
}, 1500);

// main-product tabbing content

$(document).ready(function() {
  $('.accordion .accordion__group').each(function() {
    var label = $(this).find('.accordion__label').text().trim();
    if (label === 'Fabric Care') {
      $('#fabric-care').empty();
      $(this).appendTo('#fabric-care');
    } else if (label === 'Shipping & Returns') {
      $('#shipping_returns').empty();
      $(this).appendTo('#shipping_returns');
    }
  });

  $(document).on("click", ".yotpo-small", function() {
      $('.review_tab').click();
      $('html, body').animate({
          scrollTop: $("#tab-review").offset().top
      }, 2000);
  });
  
});

// main-product tabbing content




